module.exports = __webpack_public_path__ + "img/ip.906a07bb.png";